var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"ma-0",attrs:{"dense":_vm.dense,"color":"primary","disabled":_vm.disabled,"label":_vm.$t(_vm.label),"hide-details":_vm.hideDetails},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }